import { isNull } from 'lodash';

// 'RejectedBySegregator'

const validTypes = [
	'VerifiedBySegregator',
	'VerifiedByCashier',
	'RejectedByCashier',
	'PartialVerifiedByCashier',
];

export function checkDisabled(type) {
	if (isNull(type)) {
		return false;
	}

	return validTypes?.includes(type);
}

export function getCashMaxAmount(invoices = []) {
	/**
	 * To calculate max allowed amount as cash collection for all bills
	 */

	const storeWise = invoices?.[0]?.store_cash_limit_allowed;

	const allInvoicesWise = invoices?.reduce(
		(acc, curr) => acc + Number(curr?.cash_limit_allowed),
		0
	);

	return Math.min(storeWise, allInvoicesWise);
}
